export const FRANQUEADO_PLANEJADOR = 'franqueado_planejador'
export const FRANQUEADO_EXPANSAO = 'franqueado_expansao'